import { AxiosResponse } from 'axios'
import apiRequest from '@/apiRequest'
import ApiRequestPaths from '@/apiRequestPaths'

export interface CatalogItem {
  id: string,
  title: string,
  available: boolean,
  price: number,
  imageUrl: string,
  productUrl: string,
  categories: string[]
}

export interface ProductDetailsParams {
  catalogId: string
  productId: string
}

export class PostApiRequest {

  static async getPost(productDetailsRequest: ProductDetailsParams): Promise<AxiosResponse<any>> {

    return apiRequest.get<any>(ApiRequestPaths.GET_PRODUCT_FROM_CATALOG
        .replace('{catalogId}', productDetailsRequest.catalogId)
        .replace('{productId}', productDetailsRequest.productId))
  }

}

